/// <reference types="google.maps" />
// Google Maps JS loader — fetches the browser key from the server (kept out of the bundle)
// and loads the Maps JS SDK with it. The browser key must be restricted by HTTP referrer in
// Google Cloud Console.
import { getMapsBrowserKey } from "./maps.functions";
import { mapsEnabled } from "./browser-paid-apis";

let promise: Promise<typeof google> | null = null;

function timeoutAfter<T>(promiseToRace: Promise<T>, ms: number, message: string): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = window.setTimeout(() => reject(new Error(message)), ms);
    promiseToRace
      .then(resolve)
      .catch(reject)
      .finally(() => window.clearTimeout(timer));
  });
}

export function loadGoogleMaps(language = "en"): Promise<typeof google> {
  if (typeof window === "undefined") return Promise.reject(new Error("SSR"));
  // Kill switch de custo do browser (H.4): nenhuma carga do SDK é feita.
  if (!mapsEnabled()) return Promise.reject(new Error("maps_disabled"));
  if ((window as any).google?.maps) return Promise.resolve((window as any).google);
  if (promise) return promise;

  promise = (async () => {
    const { key } = await timeoutAfter(
      getMapsBrowserKey(),
      8000,
      "Não foi possível carregar o Google Maps. Verifica a ligação e tenta novamente.",
    );
    return new Promise<typeof google>((resolve, reject) => {
      const cbName = `__gmapsCb_${Date.now()}`;
      let settled = false;
      const cleanup = () => {
        window.clearTimeout(timeout);
        delete (window as any)[cbName];
      };
      (window as any)[cbName] = () => {
        if (settled) return;
        settled = true;
        resolve((window as any).google);
        cleanup();
      };
      const s = document.createElement("script");
      s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places,geometry&language=${encodeURIComponent(language)}&loading=async&callback=${cbName}`;
      s.async = true;
      s.defer = true;
      const timeout = window.setTimeout(() => {
        if (settled) return;
        settled = true;
        cleanup();
        promise = null;
        reject(new Error("Não foi possível carregar o Google Maps. Verifica a ligação e tenta novamente."));
      }, 12000);
      s.onerror = () => {
        if (settled) return;
        settled = true;
        cleanup();
        promise = null;
        reject(new Error("Não foi possível carregar o Google Maps. Verifica a ligação e tenta novamente."));
      };
      document.head.appendChild(s);
    });
  })().catch((error) => {
    promise = null;
    throw error;
  });
  return promise;
}
